import React, {useState} from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import FlightIcon from "@mui/icons-material/Flight";
import PublicIcon from "@mui/icons-material/Public";
import HotelIcon from "@mui/icons-material/Hotel";
import MapIcon from "@mui/icons-material/Map";
import KazakhstanMap from "../Map";
import { kazakhstanRegions } from "../../../model/regions";

const TourismPage: React.FC = () => {

    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [hoveredRegion, setHoveredRegion] = useState<string | null>(null);


    const handleRegionClick = (region: any) => {
        setSelectedRegion(region.name);
        console.log('Выбран регион:', region);
    };

    const handleRegionHover = (region: any) => {
        setHoveredRegion(region ? region.name : null);
    };
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            {/* Заголовок */}
            <Typography variant="h4" fontWeight={700} gutterBottom>
                Туризм
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Одна из приоритетных и динамично развивающихся отраслей экономики Казахстана
            </Typography>

            {/* Основной блок */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Grid container spacing={4}>
                    {/* Левая колонка: возможности */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                            Туризм в Казахстане: возможности и драйверы роста
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><CheckIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Природные и культурные достопримечательности привлекают туристов со всего мира" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><CheckIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Капиталовложения в туристскую инфраструктуру стимулируют развитие смежных отраслей (транспорт, связь, питание)" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><CheckIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Поддержка экотуризма, гастротуризма, санаторно-курортного лечения" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><CheckIcon color="primary" /></ListItemIcon>
                                <ListItemText primary="Устойчивый рост внутреннего и въездного туризма" />
                            </ListItem>
                        </List>
                    </Grid>

                    {/* Правая колонка: карта */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                width: "100%",
                                backgroundColor: "#e3f2fd",
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#1976d2",
                                fontWeight: 600,
                            }}
                        >
                            <KazakhstanMap
                                regions={kazakhstanRegions}
                                onRegionClick={handleRegionClick}
                                onRegionHover={handleRegionHover}
                                defaultFill="#5764f7"
                                hoverFill="#4254f5"
                                activeFill="#3244d0"
                            />
                        </Box>
                    </Grid>
                </Grid>

                {/* Показатели */}
                <Grid container spacing={3} sx={{ mt: 4 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper sx={{ p: 2, textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={700}>5,3 млн</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Общее количество туристов
                            </Typography>
                            <FlightIcon sx={{ color: "#1976d2", mt: 1 }} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper sx={{ p: 2, textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={700}>179,4 млрд ₸</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Объем капиталовложений в отрасль
                            </Typography>
                            <PublicIcon sx={{ color: "#1976d2", mt: 1 }} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper sx={{ p: 2, textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={700}>52,1%</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Рост доли МСБ за 6 лет
                            </Typography>
                            <MapIcon sx={{ color: "#1976d2", mt: 1 }} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper sx={{ p: 2, textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={700}>$2,3 млрд</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Экспортная выручка
                            </Typography>
                            <HotelIcon sx={{ color: "#1976d2", mt: 1 }} />
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>

            {/* Возможности для капиталовложений */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    Возможности для капиталовложений
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText primary="Развитие приоритетных туристических зон: Алаколь, Зайсан, Баянаул, Туркестан, Боровое" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Налоговые преференции, упрощенные условия для инвесторов" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Программы поддержки от Компания, DAMU, БРК" />
                    </ListItem>
                </List>
            </Paper>
        </Container>
    );
};

export default TourismPage;